var delta = delta || {};
delta.chatYPTC = function () {
    var

        _$wrapper = null,

        //set to true when a popup is open, can't open another
        _popup_open = false,

        //our inner content, we are updating this with ajax
        _$divChatYPTCInner = null,

    //
    // init 
    //
    init = function () {
        _$wrapper = $('.layout-chat-yptc');

        if (_$wrapper.length > 0) {
            //get the elems
            _$divChatYPTCInner = _$wrapper.find('#chat-yptc-inner');

            disableEnterKey();
            setupDisconnect();
            setupConnectQBO();
            newChat();
            deleteChat();
        }
    },

    disableEnterKey = function () {
        document.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
                event.preventDefault();
            }
        });
    },




    //
    // setup the disconnect quickbooks link
    //
    setupDisconnect = function () {
        _$wrapper.on('click', '#lnkDisconnect', function () {
            delta.qboAuth.disconnect('/chatyptc');
            return false;
        });
    },

    //
    // Connect to Quickbooks button, save pageParams to sesstion storage first
    //
    setupConnectQBO = function() {
        _$wrapper.on('click', '#btnConnectQBO', function() {
            delta.qboAuth.connect('/chatyptc', $(this).attr('data-url'));
            return false;
        });
    },

    //
    // setup the add client link
    //
    newChat = function () {
        $('#lnkAddChat').on('click', function () {

            if (!_popup_open) {
                _popup_open = true;

                delta.ajax.get(
                    '/ChatYPTC/New',
                    function (html) {
                        delta.popup.open({
                            type: 'confirm',
                            title: 'New Chat Session',
                            content: html,
                            afterOpen: function () {
                                _popup_open = false;
                            },
                            okCallback: function ($popup) {
                                $('#autoPopup_1 .modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3 mr10"></i>');
                                var formData = new FormData();
                                $popup.find('.modal-body').find('input, hidden, select').each(function () {
                                    var $elem = $(this);
                                    formData.append($elem.attr('name'), $elem.val());
                                });

                                delta.ajax.postFormData(
                                    '/ChatYPTC/New',
                                    formData,
                                    function (result) {
                                        if (result.isValid) {
                                            //close the popup
                                            delta.popup.close($popup);

                                            //redirect
                                            window.location.href = "/ChatYPTC/SelectChat?chatID=" + result.chatID + "&" + delta.pageParams.getPageParams();

                                        } else {
                                            $popup.find('.modal-body').html(result.html);
                                            $('#autoPopup_1  .modal-footer .fa-spinner').remove();
                                            delta.popup.enableButtons($popup);
                                        }
                                    }
                                );

                                return false;
                            }
                        });

                    }
                );
            }
        });
    },

    //
    // setup delete chat link
    //
    deleteChat = function () {
        _$wrapper.on('click', '.lnkChatDelete', function () {

            var $a = $(this);
            var chatID = $a.attr('data-chat-id');
            var title = $a.closest('tr').find('td').eq(0).find('a').text();
            var $row = $a.closest('tr');

            delta.popup.open({
                type: 'confirm',
                title: 'Delete Chat Session',
                content: 'Are you sure you want to delete the <b>' + title + '</b> chat session?',
                okButtonText: 'Delete',
                okCallback: function ($popup) {
                    $('#autoPopup_1 .modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3 mr10"></i>');
                    delta.ajax.get(
                        '/ChatYPTC/Delete?chatID=' + chatID,
                        function () {
                            document.location.reload();
                        }
                    );

                    return false;
                }
            });
        });
    },






    //
    // called from data pill js
    //
    timerCallback = function() {
        delta.ajax.getSuppressErrors(
            '/chatyptc/chatyptcinner',
            function (html) {
                _$divChatYPTCInner.html(html);
            }
        );
    },

    dummy = function () { };

    $(document).ready(init);

    return {
        timerCallback: timerCallback
    }
}();







